import{styled as t}from"@mui/material/styles";const i=t("div")({"ul:first-of-type":{marginTop:0},"p:first-of-type:empty":{display:"none"}});export{i as BodyWrapper};
//# sourceMappingURL=styles.js.map
